import applicationSubstatuses from './application-substatuses';

export default {
  [applicationSubstatuses.offerMade]: 'Offer Made',
  [applicationSubstatuses.hired]: 'Hired',
  [applicationSubstatuses.notAFit]: 'Not a Fit',
  [applicationSubstatuses.notHired]: 'Not Hired',
  [applicationSubstatuses.offerDeclined]: 'Offer Declined',
  [applicationSubstatuses.possibleMatch]: 'Possible Match',
  [applicationSubstatuses.shortlisted]: 'Shortlisted',
};


// WEBPACK FOOTER //
// ./src/constants/application-substatus-names.js